import React from 'react';
import { useSelector } from 'react-redux';
import { EditWithIcon, TagComponent, TypeRow } from 'components';
import { goalDataTypeEnums, Images, renderGoalTypes, useModal, PermissionList, RolePermission, tagEnums } from 'utils';
import { AddGoal } from '../addGoal';
import { convertGoalEnums } from '../../../../fragments/client/clientSingle/clientClinical/goals/constants';

export const LibraryGoalDetailsHeader = ({ requestParams, afterSuccess }) => {
    const { goalById } = useSelector((state) => ({
        goalById: state.library.goalById,
    }));
    const { open } = useModal();
    const hasPermission = RolePermission([PermissionList.GOAL_CREATE?.code]);

    return (
        <div>
            <div className="space-between-flex-start">
                <div className="goal-detail-name-type-box">
                    <p>{goalById?.name}</p>
                    {goalById?.domain?.name && <div>{goalById?.domain?.name}</div>}
                </div>

                <div className="flex-align-center" style={{ gap: 12 }}>
                    <TagComponent
                        userInfo={goalById}
                        module={tagEnums.LIBRARY_GOAL}
                        singleView
                        maxTags={null}
                        notSetText={'No tags added'}
                        afterSuccess={afterSuccess}
                    />
                    {hasPermission && (
                        <EditWithIcon
                            icon={Images.editAuth}
                            type={'button'}
                            handleClick={() => open(<AddGoal requestParams={requestParams} info={goalById} />)}
                        />
                    )}
                </div>
            </div>

            <div className="goal-detail-information">
                <div>
                    <p style={{ fontWeight: 600 }}>Data Collection Methods: </p>
                    <p>{renderGoalTypes(goalById?.dataType)}</p>
                </div>
                <div>
                    <p style={{ fontWeight: 600 }}>Teaching Method: </p>
                    <p>{convertGoalEnums(goalById?.teachingMethod)}</p>
                </div>
                <div>
                    <p style={{ fontWeight: 600 }}>Type: </p>
                    <p>{convertGoalEnums(goalById?.type)}</p>
                </div>
                <div>
                    <p style={{ fontWeight: 600 }}>Min Trials: </p>
                    <p>{goalById?.minTrials}</p>
                </div>
                <div>
                    <p style={{ fontWeight: 600 }}>Max Trials: </p>
                    <p>{goalById?.maxTrials ?? 'No limit'}</p>
                </div>

                {goalById?.dataType === goalDataTypeEnums.RATE && (
                    <div>
                        <p style={{ fontWeight: 600 }}>Rate Measured Per: </p>
                        <p>
                            <TypeRow text={goalById?.timeUnit} />
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
